import * as React from 'react';
type Props = {
  className?: string;
};
export function Sandwich({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Sandwich"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 5.53705C11.7772 5.53705 11.5607 5.61148 11.385 5.74852L11.3837 5.74951L5.91581 9.99999H18.0842L12.6163 5.74951L12.615 5.74852C12.4393 5.61148 12.2228 5.53705 12 5.53705ZM10.1558 4.17088C10.6828 3.76012 11.3318 3.53705 12 3.53705C12.6682 3.53705 13.3172 3.76012 13.8442 4.17088L21.6059 10.2044C21.6236 10.2179 21.6408 10.2319 21.6575 10.2465C21.7137 10.2956 21.7635 10.3501 21.8066 10.4087C21.9346 10.5834 22.0024 10.7952 22 11.0111V14C22 14.3541 21.9061 14.6985 21.7321 15C21.9061 15.3015 22 15.6459 22 16V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H16.635L16.5182 20.1402L16.5142 20.145C16.0094 20.7432 15.2907 21.1203 14.5116 21.196C13.7329 21.2716 12.9555 21.04 12.3451 20.5507L12.3442 20.55L11.6559 20H4C3.46957 20 2.96086 19.7893 2.58579 19.4142C2.21071 19.0391 2 18.5304 2 18V16C2 15.6459 2.09391 15.3015 2.26794 15C2.09391 14.6985 2 14.3541 2 14V11.0111C1.99969 10.9832 2.00056 10.9554 2.00258 10.9277C2.02197 10.6564 2.14958 10.415 2.34248 10.2465C2.35919 10.232 2.37638 10.2179 2.39403 10.2044L10.1558 4.17088ZM9.15271 18L6.64956 16H4V18L9.15271 18ZM7 14H19.5H20V12H4V14H7ZM17.365 16H9.85358L13.5942 18.9887L13.5958 18.99C13.7993 19.1533 14.0586 19.2306 14.3183 19.2054C14.5771 19.1802 14.8159 19.0552 14.9841 18.857L17.365 16ZM19.9684 16H20V18H18.3017L19.9684 16Z"
        fill="currentColor"
      />
    </svg>
  );
}
